import { darken } from 'polished';
import styled from 'styled-components';

export const FormContainer = styled.form<{ flex?: number }>`
  flex: ${({ flex }) => (flex !== undefined ? flex : 1)};
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.metrics.padding};
  gap: ${({ theme }) => theme.metrics.gap};
  border-radius: ${({ theme }) => theme.metrics.innerRadius};
  border: 1px solid ${({ theme }) => darken(0.1, theme.colors.background)};
`;
